import { PageLinkFragment, TabularMenuFragment, UrlLinkFragment } from '@ts/operations'
import React, { useMemo } from 'react'

import Tabs from './StoreSalesTabs'
import { TabProps } from './Tab'

export type TabsProviderProps = {
  menuItems: TabularMenuFragment['menuItems']
  onChange?: (i?: number, url?: string) => void
  page?: string
  selectedMenuIndex?: number | null
}

const pageTab = (link: PageLinkFragment, page?: string, label?: string) => {
  return {
    label,
    page,
    url: link.page?.path || '',
  }
}

const urlTab = ({ url, target }: UrlLinkFragment, label?: string) => {
  return {
    label,
    target,
    url,
  }
}

const TabsProvider = ({ menuItems, selectedMenuIndex = 0, page, onChange }: TabsProviderProps) => {
  const tabs = useMemo(
    () =>
      menuItems.reduce<TabProps[]>((acc, { label, link }) => {
        if (page && link.__typename === 'ComponentWebLinksPageLink') {
          acc.push(pageTab(link, page, label))
        } else if (link.__typename === 'ComponentWebLinksUrlLink') {
          acc.push(urlTab(link, label))
        }
        return acc
      }, []),
    [menuItems, page]
  )

  return tabs.length > 0 ? (
    <Tabs
      activeTabIndex={selectedMenuIndex}
      tabs={tabs}
      onChange={onChange ? (i, url) => onChange(i, url) : undefined}
    />
  ) : null
}

export default TabsProvider
